export const responseFetcher = async (url: string, options?: RequestInit) => {
	const res: Response = await fetch(url, options);

	if (!res.ok) {
		const errorInfo = await res.json();
		throw new Error(errorInfo.message);
	}

	return res;
};

export const jsonFetcher = async <DataType>(url: string, options?: RequestInit) => {
	return (await responseFetcher(url, options)).json() as DataType;
};
